export default "__VITE_ASSET__Dik$7BuZ__"